import React, { useState, useEffect } from 'react';
import { MessageCircle } from 'lucide-react';
import './FloatingWhatsApp.css';

const FloatingWhatsApp = ({ onClick }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Show the button immediately after component mount for a nice fade-in effect
    const timer = setTimeout(() => setIsVisible(true), 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <button
      className={`floating-whatsapp ${isVisible ? 'visible' : ''}`}
      onClick={onClick}
      aria-label="Chat on WhatsApp"
      title="Chat on WhatsApp"
    >
      <MessageCircle size={28} />
      <span className="pulse-ring"></span>
    </button>
  );
};

export default FloatingWhatsApp;